import {TSmsProps} from '../../types';
import {useSelector} from 'react-redux';
import {TState} from '../../../../redux/store.type';
import {useTranslation} from 'react-i18next';
import {SMS_MAX_CHAR} from '../../../../pages/branding/smsEditor/SmsEditor';
import EditorWrapper from '../../../textEditor/editorWrapper/EditorWrapper';
import * as css from './SmsTab.css';

const SmsTab = ({message, saveMessage, variablesType}: TSmsProps) => {
    const {t} = useTranslation('layout');
    const lang = useSelector((s: TState) => s.user.lang);
    const defaultText = message;
    
    return (
        <css.smsEditor data-cy='smsEditor'> 
            <EditorWrapper 
                text={t('freeText')} 
                limit={{maxChar:SMS_MAX_CHAR,  showCharCounter:true,showMessagesAmount:true}} 
                defaultText={defaultText} showToolbar={false} dependencies={[]} 
                events={{onChange: saveMessage,onFocus:()=>{}}}
                lang={lang}
                variablesType={variablesType}
            />
        </css.smsEditor>
    );
};

export default SmsTab;
